import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "认证状态"
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userTypeAccountStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userTypeAccountStatus", $$v);
      },
      expression: "searchForm.userTypeAccountStatus"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: null
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("待上线 "), _vm.dsx > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.dsx))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("已上线 "), _vm.ysx > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.ysx))]) : _vm._e()])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "账户状态"
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userTypeAccountStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userTypeAccountStatus", $$v);
      },
      expression: "searchForm.userTypeAccountStatus"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("在线 "), _vm.zx > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.zx))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("到期 "), _vm.dq > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.dq))]) : _vm._e()])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "昵称"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "remark", $$v);
      },
      expression: "searchForm.remark"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "所属公司"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.company,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "company", $$v);
      },
      expression: "searchForm.company"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "负责人"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.personCharge,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "personCharge", $$v);
      },
      expression: "searchForm.personCharge"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.city,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "city", $$v);
      },
      expression: "searchForm.city"
    }
  }, _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.token,
      attrs: {
        label: item.name_zh,
        value: item.name_zh
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "押金"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.depositStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "depositStatus", $$v);
      },
      expression: "searchForm.depositStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "有",
      value: 0
    }
  }), _c("el-option", {
    attrs: {
      label: "无",
      value: 1
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.exportLoading,
      expression: "exportLoading"
    }],
    attrs: {
      type: "success",
      size: "small"
    },
    on: {
      click: _vm.exportData
    }
  }, [_vm._v("导出")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          userTypeAccountStatus: 3,
          pageSize: 20
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.setLevel
    }
  }, [_vm._v("等级配置")])], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "success",
      size: "small"
    },
    on: {
      click: _vm.add
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "昵称",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          user = _ref$row.user;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-quarter-radar-pop", {
          attrs: {
            info: user === null || user === void 0 ? void 0 : user.userScore
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "160",
      prop: "remarks",
      label: "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remarkList || [],
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "110",
      label: "实名信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row, _scope$row2, _scope$row4, _scope$row5;
        return [scope.row.authType == 1 && (scope.row.authStatus == 1 || scope.row.authStatus == 2) ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("强制实名中")]) : (_scope$row = scope.row) !== null && _scope$row !== void 0 && _scope$row.authInfoRecords && scope.row.authInfoRecords.length == 0 ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            trigger: "hover"
          }
        }, [_c("div", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [!scope.row.authStatus || scope.row.authStatus == 0 || scope.row.authStatus == 3 || scope.row.authStatus == 5 ? _c("el-tag", {
          attrs: {
            type: "info"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.showUserAuthDialog(scope.row, 1);
            }
          }
        }, [_vm._v("去实名")]) : _vm._e(), scope.row.authStatus == 1 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待实名")]) : _vm._e()], 1), _c("p", [_vm._v("暂无实名信息")])]) : _c("el-popover", {
          attrs: {
            placement: "top-start",
            width: "400",
            trigger: "hover"
          }
        }, [_c("div", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [!scope.row.authStatus || scope.row.authStatus == 0 || scope.row.authStatus == 5 ? _c("el-tag", {
          attrs: {
            type: "info"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.showUserAuthDialog(scope.row, 1);
            }
          }
        }, [_vm._v("去实名")]) : _vm._e(), scope.row.authStatus == 1 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待实名")]) : _vm._e(), scope.row.authStatus == 3 && (_scope$row2 = scope.row) !== null && _scope$row2 !== void 0 && _scope$row2.authInfoRecords ? _c("el-link", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              var _scope$row3;
              return _vm.toPage((_scope$row3 = scope.row) === null || _scope$row3 === void 0 || (_scope$row3 = _scope$row3.authInfoRecords) === null || _scope$row3 === void 0 ? void 0 : _scope$row3[0]);
            }
          }
        }, [_vm._v(" " + _vm._s((_scope$row4 = scope.row) === null || _scope$row4 === void 0 ? void 0 : _scope$row4.authInfoRecords[0].idcardName))]) : _vm._e()], 1), _c("div", [_c("el-table", {
          attrs: {
            data: ((_scope$row5 = scope.row) === null || _scope$row5 === void 0 ? void 0 : _scope$row5.authInfoRecords) || []
          }
        }, [_c("el-table-column", {
          attrs: {
            width: "160",
            property: "idcardName",
            label: "姓名"
          }
        }), _c("el-table-column", {
          attrs: {
            width: "180",
            property: "idcardNumber",
            label: "身份证号"
          }
        }), _c("el-table-column", {
          attrs: {
            width: "100",
            property: "createdAt",
            label: "实名时间"
          }
        })], 1), _c("div", {
          staticStyle: {
            "margin-top": "10px",
            display: "flex",
            "justify-content": "flex-end"
          }
        }, [_c("el-button", {
          attrs: {
            type: "primary",
            size: "mini",
            round: ""
          },
          on: {
            click: function click($event) {
              return _vm.showUserAuthDialog(scope.row, 2);
            }
          }
        }, [_vm._v("重新实名")])], 1)], 1)])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "brandQuarterUser.city",
      width: "100",
      label: "城市"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      label: "所属公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row7;
        return [_c("el-link", {
          attrs: {
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              var _scope$row6;
              return _vm.$router.push("/quarter/company?company=".concat((_scope$row6 = scope.row) === null || _scope$row6 === void 0 || (_scope$row6 = _scope$row6.brandQuarterUser) === null || _scope$row6 === void 0 ? void 0 : _scope$row6.company));
            }
          }
        }, [_vm._v(" " + _vm._s((_scope$row7 = scope.row) === null || _scope$row7 === void 0 || (_scope$row7 = _scope$row7.brandQuarterUser) === null || _scope$row7 === void 0 ? void 0 : _scope$row7.company) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "消息数",
      prop: "imCount",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.imCount || 0,
            userId: scope.row.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "用户状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.userTypeAccountStatus == 0 && !scope.row.preOpen ? _c("el-tag", {
          attrs: {
            type: "info"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.$router.push("/quarter/apartment/audit?phone=".concat(scope.row.phone, "&userTypeStatus=all"));
            }
          }
        }, [_vm._v("待上线")]) : _vm._e(), scope.row.userTypeAccountStatus == 0 && scope.row.preOpen ? _c("el-tag", {
          attrs: {
            type: "success"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.$router.push("/quarter/apartment/audit?phone=".concat(scope.row.phone, "&userTypeStatus=all"));
            }
          }
        }, [_vm._v("预上线")]) : _vm._e(), scope.row.userTypeAccountStatus == 1 ? _c("el-tag", {
          attrs: {
            type: "success"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.goQuarterHouseList(scope.row);
            }
          }
        }, [_vm._v("在线")]) : _vm._e(), scope.row.userTypeAccountStatus == 2 ? _c("el-tag", {
          attrs: {
            type: "danger"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.goQuarterHouseList(scope.row);
            }
          }
        }, [_vm._v("到期")]) : _vm._e(), scope.row.userTypeAccountStatus == 3 ? _c("el-tag", [_vm._v("已上线")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "brandQuarterUser.endTime",
      width: "160",
      sortable: "",
      label: "账户到期时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "brandQuarterUser.remainingDays",
      width: "100",
      label: "剩余天数"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "订单数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row8;
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goQuarterOrderRecord(scope.row);
            }
          }
        }, [_vm._v(_vm._s((_scope$row8 = scope.row) === null || _scope$row8 === void 0 || (_scope$row8 = _scope$row8.brandQuarterUser) === null || _scope$row8 === void 0 ? void 0 : _scope$row8.orderTotal))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "brandQuarterUser.personChargeName",
      width: "120",
      label: "负责人"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "版本信息",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-app-version", {
          attrs: {
            info: scope.row.newestAppInfo || scope.row.appInfo || {}
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "brandQuarterUser.startTime",
      label: "账户首次开通时间",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "220",
      fixed: "right",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.operate.cancelBq == 1 && !scope.row.preOpen ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.cancel(scope.row);
            }
          }
        }, [_vm._v("取消季度")]) : _vm._e(), scope.row.brandStatus == 3 && scope.row.accountStatus == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.brandAccountRefund(scope.row);
            }
          }
        }, [_vm._v("退款")]) : _vm._e(), scope.row.operate.edit == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), scope.row.operate.renew == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.renew(scope.row);
            }
          }
        }, [_vm._v("续费")]) : _vm._e(), scope.row.operate.stop == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.stop(scope.row);
            }
          }
        }, [_vm._v("停用")]) : _vm._e(), scope.row.operate.transfer == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.transfer(scope.row);
            }
          }
        }, [_vm._v("转移")]) : _vm._e(), scope.row.operate.openAccount == 1 && !scope.row.preOpen ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.open(scope.row);
            }
          }
        }, [_vm._v("开通账号")]) : _vm._e(), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row);
            }
          }
        }, [_vm._v("备注 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "充值",
      visible: _vm.topUpDialogVisible,
      width: "300px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.topUpDialogVisible = $event;
      }
    }
  }, [_c("el-form", [_c("el-form-item", [_c("el-input", {
    attrs: {
      placeholder: "请输入充值金额"
    },
    model: {
      value: _vm.amount,
      callback: function callback($$v) {
        _vm.amount = _vm._n($$v);
      },
      expression: "amount"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.brandTopUp
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("editUser", {
    attrs: {
      title: _vm.editType == 1 ? "编辑" : _vm.editType == 2 ? "开通季度账户" : "续费",
      visible: _vm.editVisible,
      editType: _vm.editType,
      data: _vm.current,
      userId: _vm.currentUserId,
      "close-on-click-modal": false,
      width: "400px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editVisible = $event;
      },
      confirm: _vm.getData
    }
  }), _c("el-dialog", {
    attrs: {
      title: "转移新账号",
      width: "430px",
      visible: _vm.transferVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.transferVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-width": "60px",
      size: "small"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    attrs: {
      autofocus: "",
      autocomplete: "off"
    },
    model: {
      value: _vm.transferPhone,
      callback: function callback($$v) {
        _vm.transferPhone = $$v;
      },
      expression: "transferPhone"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.transferVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      disabled: !_vm.transferPhone,
      loading: _vm.transferLoading
    },
    on: {
      click: _vm.queryTransfer
    }
  }, [_vm._v(_vm._s(_vm.transferLoading ? "查询转移细节..." : "确 定"))])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: _vm.userAuthDialogType == 1 ? "\u53BB\u5B9E\u540D" : "\u91CD\u65B0\u5B9E\u540D",
      visible: _vm.userAuthDialogVisible,
      width: "330px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.userAuthDialogVisible = $event;
      }
    }
  }, [_vm.userAuthDialogType == 2 ? _c("el-alert", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      title: "该用户已绑定实名信息，确认继续操作？",
      type: "error",
      closable: false
    }
  }) : _vm._e(), _c("el-form", {
    attrs: {
      "label-width": "60px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.currentRow.name,
      callback: function callback($$v) {
        _vm.$set(_vm.currentRow, "name", _vm._n($$v));
      },
      expression: "currentRow.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.currentRow.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.currentRow, "phone", _vm._n($$v));
      },
      expression: "currentRow.phone"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setQuarterUserAuth
    }
  }, [_vm._v("确定")]), _c("el-button", {
    on: {
      click: function click($event) {
        _vm.userAuthDialogVisible = false;
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRow.id,
      remark: _vm.currentRow.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  }), _c("CityLevelModal", {
    ref: "cityLevelModal",
    attrs: {
      cities: _vm.cityList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };